module.exports = __webpack_public_path__ + "img/isle-of-man.a870d25f.svg";